module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-index default-content-container",
    class: {
      landscape: _vm.isLandscape, 'portrait': _vm.isPortrait, mobile: _vm.isMobile
    }
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Henning Maier-Jantzen "), _c('em', [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "index-container margin-top-container",
    style: ({
      marginRight: _vm.windowMargin + 'px'
    })
  }, _vm._l((_vm.filteredProjects), function(project, index) {
    return (project.type != 'homepage') ? _c('div', {
      key: project.id,
      staticClass: "index-project",
      attrs: {
        "id": 'index-' + project.id
      }
    }, [_c('div', {
      staticClass: "index-project-info"
    }, [_c('span', {
      staticClass: "index-project-title"
    }, [_vm._v(_vm._s(project.title[_vm.lang]))]), _vm._v(" "), _c('span', {
      staticClass: "index-project-category"
    }, [_vm._v(_vm._s(_vm.getCategoryBySlug(project.category[0])))]), _vm._v(" "), _c('span', {
      staticClass: "index-project-client"
    }, [_vm._v(_vm._s(project.client))])]), _vm._v(" "), _c('div', {
      staticClass: "index-project-track-wrapper"
    }, [_c('div', {
      staticClass: "track-nav track-nav-left",
      on: {
        "click": function($event) {
          _vm.trackMoveLeft(project.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/images/icons/HMJ-Cursor-Scroll-Left.svg",
        "alt": "left arrow"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "track-nav track-nav-right",
      on: {
        "click": function($event) {
          _vm.trackMoveRight(project.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/images/icons/HMJ-Cursor-Scroll-Right.svg",
        "alt": "left arrow"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "index-project-slide-track"
    }, _vm._l((project.images), function(image, imageIndex) {
      return _c('div', {
        key: image.file,
        staticClass: "index-project-slide"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'project-slide',
            params: {
              slug: project.id,
              index: imageIndex
            }
          }
        }
      }, [_c('div', {
        staticStyle: {
          "background": "#E5E5E5"
        },
        style: ({
          height: 133 + 'px',
          width: 133 * (image.view.width / image.view.height) + 'px'
        })
      }, [_c('img', {
        staticClass: "index-image",
        style: ({
          height: 133 + 'px',
          width: 133 * (image.view.width / image.view.height) + 'px'
        }),
        attrs: {
          "id": 'index-' + project.id + '--' + imageIndex,
          "src": "/static/images/placeholder.gif",
          "data-src": '/static/assets2/small/' + project.directory + '/' + image.file
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "download hide-for-small-only hide-for-medium-only",
        on: {
          "click": function($event) {
            _vm.download(image)
          }
        }
      }, [_vm._m(0, true)])], 1)
    }), 0)])]) : _vm._e()
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('img', {
    attrs: {
      "src": "/static/images/icons/HMJ-Download.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b8417b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 187
// module chunks = 2